import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const  schema = yup.object().shape({
  tabelog_url: yup.string().required('入力必須項目です'),
});
export const useRegisterKuitanSettingForm = () => {
  const { handleSubmit, register, formState: { errors, isSubmitting } } = useForm({resolver: yupResolver( schema),});
  return {
    handleSubmit,
    register,
    isSubmitting,
    errors,
  };
};